
































import { defineComponent, onBeforeUnmount, onMounted, PropType, toRefs, ref } from '@vue/composition-api';
import AutoSave from './index';
import { AdgroupFormData, CampaignFormData, SketchRelatedData } from '@tt4b/ttam-enums';

const name = 'ttam-auto-save-compose';
export default defineComponent({
  name,
  components: {
    TtamAutoSaveExitButton: AutoSave.TtamAutoSaveExitButton,
    TtamAutoSaveStatus: AutoSave.TtamAutoSaveStatus,
    TtamAutoSaveExitDialog: AutoSave.TtamAutoSaveExitDialog,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    adgroupSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    creativeSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    isSupportDraft: {
      type: Boolean,
      default: false,
    },
    isReachLimitPopoverAutoShow: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { isSupportDraft, campaignSketchRelatedData, adgroupSketchRelatedData, creativeSketchRelatedData } =
      toRefs(props);
    const autoSaveStatusRef = ref();
    const {
      autoSaveExitButtonDisabled,
      exitDialogVisible,
      isShowDiscardDropDown,
      handleExitByClickExitButton,
      handleExitByClickDiscard,
      handleExitByClickHeaderMenu,
      handleExitDialogClose,
      handleExitDialogExit,
    } = AutoSave.useAutoSaveExitHandler({
      isSupportDraft,
      campaignSketchRelatedData,
      adgroupSketchRelatedData,
      creativeSketchRelatedData,
      emit,
    });

    const handleRetry = (isCommonError: boolean) => {
      emit('retry', isCommonError);
    };

    const handleManageDraft = () => {
      emit('manage-draft');
    };

    onMounted(() => {
      if (window.TT4BMain) {
        // 该方法在 header 代码中定义, saving/reach limit/common error 状态下的弹窗
        window.TT4BMain.showDraftSavingMessage = handleExitByClickHeaderMenu;
      }
    });

    onBeforeUnmount(() => {
      delete window.TT4BMain?.showDraftSavingMessage;
    });

    const updatePopper = () => {
      autoSaveStatusRef.value.updatePopper();
    };

    return {
      name,
      autoSaveStatusRef,
      autoSaveExitButtonDisabled,
      exitDialogVisible,
      isShowDiscardDropDown,
      handleExitByClickExitButton,
      handleExitByClickDiscard,
      handleExitDialogClose,
      handleExitDialogExit,

      handleRetry,
      handleManageDraft,
      updatePopper,
    };
  },
});
